import actions from './actions'
import getters from './getters'
import * as types from './types'

const state = {
  partners: [],
  filters: {
    accountId: '',
    investorId: '',
    currency: '',
    active: '',
    product: 'ETR'
  },
  pagination: {
    page: 1,
    itemsPerPage: 20
  },
  totalItems: 0,
  strategiesETR: {
    isLoading: false,
    data: []
  },
  strategiesETP: {
    isLoading: false,
    data: []
  }
}

const mutations = {
  [types.SET_PAGINATION](state, value) {
    state.pagination = value
  },
  [types.SET_TOTAL_ITEMS](state, value) {
    state.totalItems = value
  },
  [types.SET_FILTERS](state, { key, value }) {
    state.filters = {
      ...state.filters,
      [key]: value
    }
  },
  [types.SET_PARTNERS](state, partners) {
    state.partners = partners
  },
  // ETR
  [types.SET_IS_ETR_LOADING](state, isLoading) {
    state.strategiesETR.isLoading = isLoading
  },
  [types.SET_STRATEGIES_ETR](state, strategiesETR) {
    state.strategiesETR.data = strategiesETR
  },
  // ETP
  [types.SET_IS_ETP_LOADING](state, isLoading) {
    state.strategiesETP.isLoading = isLoading
  },
  [types.SET_STRATEGIES_ETP](state, strategiesETP) {
    state.strategiesETP.data = strategiesETP
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
